import { format, formatDistance, formatDistanceStrict, parseISO, isDate, differenceInDays } from 'date-fns'

export default (date: string | Date, stringFormat?: string): string => {
  if (!date) {
    return ''
  }

  const dateToFormat = isDate(date) ? (date as Date) : parseISO(date as string)

  if (stringFormat === 'fromNowStrict') {
    return formatDistanceStrict(dateToFormat, new Date(), { addSuffix: true })
  }

  if (stringFormat === 'fromNow') {
    return formatDistance(dateToFormat, new Date(), { addSuffix: true })
  }

  if (stringFormat) {
    return format(dateToFormat, stringFormat)
  }

  return format(dateToFormat, 'MMMM do, yyyy')
}

export const daysSince = (dateString: string) => differenceInDays(new Date(), new Date(dateString))

export const getDateAfterDaysAndMonths = (days?: number | null | undefined, months?: number | null | undefined): Date => {
  const date = new Date()
  date.setDate(date.getDate() + (days || 0))
  date.setMonth(date.getMonth() + (months || 0))
  return date
}
